import React from "react";
import { Link } from "react-router-dom";
import {
  resolveMediaUrl,
  resolveMediaBackground,
  handleMediaImgError,
} from "../Helper/mediaUrl";

function AttributionLink({ label, to, kind }) {
  if (!to) {
    return null;
  }
  return (
    <Link to={to} className={`community-post__attr community-post__attr--${kind}`}>
      {label}
    </Link>
  );
}

/**
 * Shared Community post header — cover behind avatar, name, handle, timestamp.
 * One implementation for My Feed, Profile timeline, and future entity feeds.
 */
function CommunityPostHeader({
  item = null,
  displayName = "Member",
  handle = null,
  avatar = null,
  cover = null,
  authorPath = null,
  timestamp = "",
  createdAt = null,
}) {
  const coverPath =
    cover ||
    (item && item.author && (item.author.cover || item.author.community_cover)) ||
    null;
  const coverStyle = coverPath
    ? { backgroundImage: resolveMediaBackground(coverPath) }
    : undefined;

  return (
    <div
      className={
        "community-post__stage" +
        (coverPath ? " community-post__stage--cover" : "")
      }
      style={coverStyle}
      role={coverPath ? "img" : undefined}
      aria-label={coverPath ? `${displayName} cover` : undefined}
    >
      <header className="community-post__header">
        {authorPath ? (
          <Link
            to={authorPath}
            className="community-post__avatar-link"
            aria-label={displayName}
          >
            <span className="community-post__avatar" aria-hidden="true">
              {avatar ? (
                <img
                  src={resolveMediaUrl(avatar)}
                  alt=""
                  onError={handleMediaImgError}
                />
              ) : (
                <span>{(displayName || "?").charAt(0).toUpperCase()}</span>
              )}
            </span>
          </Link>
        ) : (
          <span className="community-post__avatar" aria-hidden="true">
            {avatar ? (
              <img
                src={resolveMediaUrl(avatar)}
                alt=""
                onError={handleMediaImgError}
              />
            ) : (
              <span>{(displayName || "?").charAt(0).toUpperCase()}</span>
            )}
          </span>
        )}
        <div className="community-post__byline">
          <div className="community-post__names">
            {authorPath ? (
              <Link to={authorPath} className="community-post__display-name">
                {displayName}
              </Link>
            ) : (
              <span className="community-post__display-name">{displayName}</span>
            )}
            {handle ? (
              <span className="community-post__handle">@{handle}</span>
            ) : null}
          </div>
          <div className="community-post__attrs">
            {item && item.creator ? (
              <AttributionLink
                kind="creator"
                label={item.creator.name}
                to={
                  item.creator.path ||
                  (item.creator.slug ? `/creator/${item.creator.slug}` : null)
                }
              />
            ) : null}
            {item && item.organization ? (
              <AttributionLink
                kind="org"
                label={item.organization.name}
                to={
                  item.organization.path ||
                  (item.organization.slug
                    ? `/organization/${item.organization.slug}`
                    : null)
                }
              />
            ) : null}
            {item && item.project ? (
              <AttributionLink
                kind="project"
                label={item.project.name}
                to={
                  item.project.path ||
                  (item.project.slug ? `/project/${item.project.slug}` : null)
                }
              />
            ) : null}
            {timestamp ? (
              <time
                className="community-post__time"
                dateTime={createdAt || undefined}
              >
                {timestamp}
              </time>
            ) : null}
          </div>
        </div>
      </header>
    </div>
  );
}

export default CommunityPostHeader;
export { AttributionLink };
